import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const TabContainer = ({
  title,
  config,
  handleChange,
  handleSubmit,
  handleChangeRadio,
}) => {
  const validaHorariosUnicos = (periodoInicio, periodoFim) => {
    return {
      error: periodoFim < periodoInicio,
    };
  };
  const valores = ["0", "2", "1", "3"];

  const validaHorarios = (config) => {
    if (
      config?.periodo01Inicio > config?.periodo01Fim &&
      config?.status !== 1
    ) {
      return true;
    } else if (
      config?.periodo02Inicio > config?.periodo02Fim &&
      config?.status !== 2
    ) {
      return true;
    } else if (
      config?.periodo02Inicio < config?.periodo01Fim &&
      config?.status === 0
    ) {
      return true;
    }
    return false;
  };
  const getLabelByValue = (val) => {
    switch (val) {
      case "0":
        return "Aberto nos 2 horários";
      case "2":
        return "Aberto apenas no horário 1";
      case "1":
        return "Aberto apenas no horário 2";
      case "3":
        return "Fechado o dia todo";
      default:
        return "";
    }
  };
  const errorText = () => {
    if (
      config?.periodo01Inicio > config?.periodo01Fim &&
      config?.status !== 1
    ) {
      return "O horário final não pode ser menor que o inicial";
    } else if (
      config?.periodo02Inicio > config?.periodo02Fim &&
      config?.status !== 2
    ) {
      return "O horário final não pode ser menor que o inicial";
    } else if (
      config?.periodo02Inicio < config?.periodo01Fim &&
      config?.status === 0
    ) {
      return "Os horários não devem convergir";
    }
    return "";
  };

  return (
    <Box sx={{ flexGrow: 5 }}>
      <Grid container spacing={0}>
        <Grid mb="2rem" size={12}>
          <Typography variant="h4" align="center">
            {title}
          </Typography>
        </Grid>
        <Grid
          size={{
            xs: 13,
            sm: 4,
          }}
        >
          <Box
            sx={{
              px: 4,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              borderRight: "1px solid lightGray",
            }}
          >
            <Typography align="center">Horário 1</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileTimePicker
                ampm={false}
                label="Horário inicial"
                disabled={["1", "3"].includes(config?.status?.toString())}
                value={config?.periodo01Inicio || new Date()}
                onChange={(value) =>
                  handleChange(value, "periodo01Inicio", config)
                }
                renderInput={(params) => (
                  <TextField {...params} fullWidth variant="outlined" />
                )}
              />
              <MobileTimePicker
                ampm={false}
                label="Horário final"
                sx={{ mt: 2 }}
                disabled={["1", "3"].includes(config?.status?.toString())}
                value={config?.periodo01Fim || new Date()}
                onChange={(value) =>
                  handleChange(value, "periodo01Fim", config)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    error={
                      validaHorariosUnicos(
                        config?.periodo01Inicio,
                        config?.periodo01Fim
                      ).error
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <Box sx={{ px: 4, gap: 2, display: "flex", flexDirection: "column" }}>
            <Typography align="center">Horário 2</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileTimePicker
                ampm={false}
                label="Horário inicial"
                slotProps={{
                  toolbar: {
                    toolbarTitle: "Escolha o horário",
                  },
                }}
                disabled={["2", "3"].includes(config?.status?.toString())}
                value={config?.periodo02Inicio || new Date()}
                onChange={(value) =>
                  handleChange(value, "periodo02Inicio", config)
                }
                renderInput={(params) => (
                  <TextField {...params} fullWidth variant="outlined" />
                )}
              />
              <MobileTimePicker
                ampm={false}
                label="Horário final"
                sx={{ mt: 2 }}
                disabled={["2", "3"].includes(config?.status?.toString())}
                value={config?.periodo02Fim || null}
                onChange={(value) =>
                  handleChange(value, "periodo02Fim", config)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    error={
                      validaHorariosUnicos(
                        config?.periodo02Inicio,
                        config?.periodo02Fim
                      ).error
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <Box sx={{ px: 4 }}>
            <FormControl component="fieldset">
              <RadioGroup aria-label="opções" name="opções">
                {valores.map((val) => (
                  <FormControlLabel
                    key={val}
                    value={val}
                    control={
                      <Radio
                        sx={{
                          color: "primary.main",
                          "&.Mui-checked": {
                            color: "primary.main",
                          },
                        }}
                        checked={config?.status?.toString() === val}
                        onClick={(e) => handleChangeRadio(e, config)}
                      />
                    }
                    label={
                      <Typography sx={{ color: "primary.main" }}>
                        {getLabelByValue(val)}
                      </Typography>
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        <Grid size={12}>
          <Box sx={{ mt: 5, display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              disabled={validaHorarios(config)}
              onClick={() => handleSubmit(config)}
            >
              Salvar
            </Button>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography sx={{ color: "red", mt: 1 }}>{errorText()}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TabContainer;
